import {useGetContainerLevelSimulationQuery} from "@ots-frontend/ots-data";
import {BeakerIcon} from "@heroicons/react/20/solid";
import {useEffect, useState} from "react";

export type ContainerLevelSimulationBadgeProps = {
  onClick: () => void;
};

/** Environment-gated header indicator. Once availability is confirmed, it polls so separate app tabs stay in sync. */
export const ContainerLevelSimulationBadge = ({onClick}: ContainerLevelSimulationBadgeProps) => {
  const [available, setAvailable] = useState(false);
  const {data: status, isError} = useGetContainerLevelSimulationQuery(undefined, {
    pollingInterval: available ? 5000 : 0,
  });

  useEffect(() => {
    if (status?.available) setAvailable(true);
  }, [status?.available]);

  if (isError || !status?.enabled) return null;

  return (
    <button
      type="button"
      onClick={onClick}
      className="inline-flex min-h-5 items-center gap-1.5 rounded-full bg-amber-500 px-2.5 py-0.5 text-[11px] font-bold tracking-wide text-amber-950 shadow-sm transition hover:bg-amber-400 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-amber-600">
      <BeakerIcon aria-hidden="true" className="size-3.5"/>
      Simulated Container Levels On
    </button>
  );
};
